import React, { useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import PackageEmpty from "../assets/svg/v2/plans/none.svg";

const BinaryTreeLoading = () => { // Recibimos la función onComplete como prop
    const { t } = useTranslation();


    return (
        <>
            <div className="flex justify-center flex-col relative w-36 group my-10 lg:mt-10 lg:my-10 cursor-pointer">
                <img
                    className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`}
                    src={PackageEmpty}
                    alt={t("_NETWORK._BINARYLOADING")}
                />
                <p className="text-white absolute -top-8 text-lg left-1/2 transform -translate-x-1/2 truncate max-w-full">{t("_NETWORK._BINARYLOADING")}</p>
            </div>
            <div className="flex flex-col w-full justify-center pb-20 my-20 ">
                <div className="flex flex-col items-center justify-center lg:flex-row lg:justify-around lg:space-x-8 w-full space-y-24 lg:space-y-0">
                    <div className="flex justify-around flex-col relative w-36 group cursor-pointer">
                        <img
                            className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`}
                            src={PackageEmpty}
                            alt={t("_NETWORK._BINARYLOADING")}
                        />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2 "> {t("_NETWORK._BINARYLOADING")} <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._LEFT")}</span></p>
                    </div>
                    <div className="flex justify-around flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`}
                            src={PackageEmpty}
                            alt={t("_NETWORK._BINARYLOADING")}
                        />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2"> {t("_NETWORK._BINARYLOADING")}  <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._RIGHT")}</span></p>
                    </div>
                </div>
            </div>
            <div className="flex flex-row w-full justify-center pb-20 my-20">
                <div className="flex flex-col items-center  lg:flex-row lg:justify-around lg:space-x-8 w-full space-y-24 lg:space-y-0">
                    <div className="flex justify-around  flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`} src={PackageEmpty} alt={"Loading"} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2">  {t("_NETWORK._BINARYLOADING")}  <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._LEFT")}</span></p>
                    </div>
                    <div className="flex justify-around  flex-col relative w-36 group cursor-pointer" >
                        <img className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`} src={PackageEmpty} alt={"Loading"} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2"> {t("_NETWORK._BINARYLOADING")}  <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._RIGHT")}</span></p>
                    </div>
                    <div className="flex justify-around  flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`} src={PackageEmpty} alt={"Loading"} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2"> {t("_NETWORK._BINARYLOADING")}  <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._LEFT")}</span></p>
                    </div>
                    <div className="flex justify-around  flex-col relative w-36 group cursor-pointer">
                        <img className={`w-32 h-32 mx-auto z-40 -bottom-10 cursor-not-allowed  opacity-10`} src={PackageEmpty} alt={"Loading"} />
                        <p className="text-white group-hover:opacity-100 transition-opacity absolute -bottom-14 left-1/2 transform -translate-x-1/2"> {t("_NETWORK._BINARYLOADING")}  <span className="block lg:hidden text-blue-200 uppercase"> {t("_NETWORK._RIGHT")}</span></p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BinaryTreeLoading;
